<template>
  <footer class="footer v2-bg-primary" style="position: relative; overflow: hidden; margin: 0 !important;font-weight: normal !important;">
    <div class="container-fluid">
      <div class="row">
        <!-- Left Side: Heading, Logo, Description -->
        <div class="col-sm-12 col-lg-6">
          <div >
            <h2 class="text-neutral-100 text-3xl md-text-4xl" style="margin-bottom: 20px;text-transform: capitalize !important; line-height: 1.25; font-weight: normal !important;">
              From Revenue<br />to Return
            </h2>
          </div>

          <div class="hidden-xs" style="padding-top: 144px;">
            <img
                src="@/assets/images/footer_logo.webp"
                alt="RRB Logo"
                width="192"
                height="128"
                style="max-width: 100%; height: auto; margin-bottom: 20px;"
            />

            <!-- Desktop Terms and Copyright -->
            <div class="text-sm text-white">
              <p class="text-white text-sm">
                Copyright © {{ new Date().getFullYear() }} The Rent Roll Broker | 
                <a v-if="footer.privacy" :href="webUrl + '/privacy'"
                class="text-secondary text-sm">Privacy</a
                >
                |
                <a v-if="footer.terms" :href="webUrl + '/terms'"
                class="text-secondary text-sm">Terms</a
                >
              </p>
            </div>

          </div>
        </div>

        <!-- Right Side: 3 Columns -->
        <div class="col-sm-12 col-lg-6">
          <div class="row">
            <!-- Services -->
            <div class="col-sm-4">
              <h3 class="text-secondary text-lg" style="text-transform: capitalize !important;font-weight: normal !important;">Services</h3>
              <ul class="list-unstyled"  >
                <li v-for="(link, index) in footer.services" :key="index"  class="text-sm">
                  <a :href="link.route">{{ link.name }} </a>
                </li>
              </ul>
            </div>

            <!-- Company -->
            <div class="col-sm-4">
              <h3 class="text-secondary text-lg" style="text-transform: capitalize !important;font-weight: normal !important;">The Rent Roll Broker</h3>
              <ul class="list-unstyled" >
                <li v-for="(link, index) in footer.rent_roll_broker" :key="index" class="text-sm">
                  <a :href="link.route">{{ link.name }} </a>
                </li>
              </ul>
            </div>

            <!-- Licensing -->
            <div class="col-sm-4">
              <h3 class="text-secondary text-lg" style="text-transform: capitalize !important;font-weight: normal !important;">Brokers</h3>
              <ul class="list-unstyled" >
                <li v-for="(license, index) in footer.license" :key="index" class="text-sm">
                  <a  :href="license.route">{{ license.name }} </a>
                </li>
              </ul>

              <!-- Desktop Social Links -->
              <div class="hidden-xs" style="margin: 50px 0 30px 0;">
                <SocialLinks class="list-inline" />
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-lg-4 visible-xs" style="padding-bottom: 40px;">
          <!-- Mobile Social Links -->
            <div class="visible-xs" style="margin-top: 50px;margin-bottom: 30px;">
              <SocialLinks class="list-inline" />
            </div>
            <img
                src="@/assets/images/footer_logo.webp"
                alt="RRB Logo"
                width="192"
                style="max-width: 100%; width: 144px; margin-top: 20px;"
            />
            <!-- Mobile-only Footer Links -->
            <div class="visible-xs text-sm" style="margin-top: 20px; margin-bottom: 48px;">
              <a v-if="footer.privacy" :href="webUrl + '/privacy-policy'"
               class="text-secondary text-sm">Privacy</a
              ><br />
              
              <a v-if="footer.terms" :href="webUrl + '/terms'"
              class="text-secondary text-sm">Terms</a>
              <p style="margin-top: 20px;" class="text-white text-sm">
                <div>Copyright © {{ new Date().getFullYear() }}</div>
                <div>The Rent Roll Broker</div>
              </p>
            </div>

            
          </div>
      </div>

      <!-- Decorative SVG -->
      <svg
          
          style="position: absolute; bottom: 0; right: 0; width: 200px; height: 200px;"
          viewBox="0 0 300 300"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
      >
        <path d="M300,0 C300,166.7 166.7,300 0,300 L300,300 Z" fill="#9361B1" />
      </svg>
    </div>
  </footer>
</template>


<script>
import SocialLinks from "@/components/SocialLinks.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    SocialLinks
  },
  data() {
    return {
      adminUrl: process.env.VUE_APP_ADMIN_URL,
      webUrl: process.env.VUE_APP_WEB_URL,
    }
  },
  computed: {
    ...mapGetters({
      footer: "app/footer"
    }),
    year() {
      return new Date().getFullYear();
    }
  }
};

// var time;
// window.onload = function() {
//   time = setTimeout(function() {
//     if (document.getElementById('main-container')) {
//       clearTimeout(time);
//     } else {
//       // document.location.reload();
//     }
//   }, 1000);
// };

</script>

<style>
@media (min-width: 768px) {
  .footer{
      padding-left: 96px;
      padding-right: 96px;
      padding-top: 80px;
      padding-bottom: 20px;
  }
}
@media (max-width: 768px) {
  .footer{
    padding-left: 32px;
    padding-right: 32px;
    padding-top: 80px;
  }
}
</style>
